// extracted by mini-css-extract-plugin
module.exports = {"hover":"CardHover_hover__OdEVj","close":"CardHover_close__W9JZD","left":"CardHover_left__GGf76","mobileViewer":"CardHover_mobileViewer__N5opY"};